function MediaImageIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
        stroke='currentColor'
        fill='none'
      >
        <rect x='2.5' y='2' width='28' height='28' rx='3' strokeWidth='2' />
        <circle cx='10.5' cy='11' r='3' strokeWidth='2' />
        <path
          d='M5.5 29L21.5235 13L30.5 19.8063'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </span>
  );
}

export default MediaImageIcon;
